import { Router } from "@reach/router"
import AreaMeasure from "components/area-measures/area-measures"
import AssetList from "components/asset-management/asset-list/asset-list"
import AssetListDetail from "components/asset-management/asset-list/detail/asset-list-detail"
import AssetManagement from "components/asset-management/asset-management"
import Attributes from "components/asset-management/attributes/attributes"
import Chart from "components/asset-management/chart/chart"
import CashFlowMap from "components/asset-management/chart/detail/cash-flow-map"
import DetailAccounts from "components/asset-management/chart/detail/detail-accounts"
import SummaryAccounts from "components/asset-management/chart/detail/summary-accounts"
import Comparison from "components/asset-management/comparison/comparison"
import ComparisonDetail from "components/asset-management/comparison/detail/comparison-detail"
import Explorer from "components/asset-management/explorer"
import PortfolioAssetDetail from "components/asset-management/portfolios/detail/portfolio-asset-detail"
import Portfolio from "components/asset-management/portfolios/portfolio"
import AMReports from "components/asset-management/reports/reports"
import { AssetManagementAuditLog } from "components/audit-log/asset-management-audit-log"
import { FolderAuditLog } from "components/audit-log/folder-audit-log"
import { PropertyAuditLog } from "components/audit-log/property-audit-log"
import { SettingsAuditLog } from "components/audit-log/settings-audit-log"
// Top level routes
import Dashboard from "components/dashboard/dashboard"
import DepartmentalLineItems from "components/departmental-line-items/departmental-line-items"
import Folder from "components/folder"
import FolderExplorer from "components/folder/explorer/folder-explorer"
import PropertyList from "components/folder/property-list"
import FolderReports from "components/folder/reports/reports"
import FolderSettings from "components/folder/settings/folder-settings"
import FolderUW from "components/folder/underwriting-workbook/folder-uw"
import Hospitality from "components/hospitality/hospitality"
import Rooms from "components/hospitality/rooms/rooms"
import FolderImportExport from "components/import-export/folder-import-export"
import PropertyImportExport from "components/import-export/property-import-export"
import Inflation from "components/inflation/inflation"
import LineItems from "components/line-items/line-items"
import LineItemsWrapper from "components/line-items/line-items-wrapper"
import MarketLease from "components/market-lease/market-lease"
import MixedUse from "components/mixed-used/mixed-use"
import Multifamily from 'components/multifamily'
import MFRentRoll from "components/multifamily/rent-roll/rent-roll"
import Downtime from "components/property-market/downtime/downtime"
import PMInflation from "components/property-market/inflation/inflation"
import PropertyMarket from "components/property-market/property-market"
import RenewalProbability from "components/property-market/renewal-probability/renewal-probability"
import VacancyCreditLoss from "components/property-market/vacancy-credit-loss/vacancy-credit-loss"
import PropertyAssetAttributes from "components/property/asset-attributes/asset-attributes"
import Defaults from "components/property/defaults/defaults"
import Property from "components/property/property"
import MFPropertyReports from "components/property/reports/reports"
import PropertySettings from "components/property/settings/property-settings"
import ValuationSettings from "components/property/valuation-settings/valuation-settings"
import NamedRecoveries from "components/recoveries/named-recoveries/named-recoveries"
import Recoveries from "components/recoveries/recoveries"
import RecoveryGroups from "components/recoveries/recovery-groups/recovery-groups"
import RecoveryPoolsDetail from "components/recoveries/recovery-pools/detail/recovery-pools-detail"
import RecoveryPools from "components/recoveries/recovery-pools/recovery-pools"
import ReportTags from "components/recoveries/report-tags/report-tags"
import TenantContributions from "components/recoveries/tenant-contributions/tenant-contributions"
import TenantGroups from "components/recoveries/tenant-groups/tenant-groups"
import RentRoll from "components/rent-roll/rent-roll"
import RentRollTab from "components/rent-roll/rent-roll/rent-roll"
import SnapshotsTable from "components/snapshots/snapshots"
import TMFreeRent from "components/tenant-market/free-rent/tm-free-rent"
import TMIncrease from "components/tenant-market/increase/tm-increase"
import TMLC from "components/tenant-market/lc/tm-lc"
import TMOC from "components/tenant-market/oc/tm-oc"
import TMPayout from "components/tenant-market/payout/tm-payout"
import TMRent from "components/tenant-market/rent/tm-rent"
import TenantMarket from "components/tenant-market/tenant-market"
import TMTI from "components/tenant-market/ti/tm-ti"
import OrgSettings from "components/user-admin/org-settings"
import UserAdmin from "components/user-admin/user-admin"
import UserGroups from "components/user-admin/user-groups"
import Users from "components/user-admin/users"
import Wrapper from 'components/wrapper'
import React from "react"


const Routes = (props: {}) => {
  return (
    <Router>
      <Wrapper path="/n">
        <Dashboard path="dashboard" />
        <AssetManagement path="asset-management">
          <Explorer path="explorer" />
          <AssetList path="asset-list" />
          <AssetListDetail path="asset-list/:assetId" />
          <Attributes path="attributes" />
          <Portfolio path="portfolios" />
          <PortfolioAssetDetail path="portfolios/:portfolioId" />
          <Chart path="chart" />
          <Comparison path="comparison" />
          <ComparisonDetail path="comparison/:comparisonId" />
          <SummaryAccounts path="chart/:chartId/summary-accounts" />
          <DetailAccounts path="chart/:chartId/detail-accounts" />
          <CashFlowMap path="chart/:chartId/cash-flow-map" />
          <AMReports path="reports" />
          <AssetManagementAuditLog path="audit-log"/>
        </AssetManagement>
        <Hospitality path="hospitality">
          <Rooms path="rooms" />
          <LineItems path="line-items" type="HOSPITALITY" />
          <DepartmentalLineItems path="departmental-line-items" type="DEPARTMENTAL" />
          <AreaMeasure path="area-measure" />
          <Inflation path="inflation" />
        </Hospitality>
        <Multifamily path="multifamily">
          <MFRentRoll path="rent-roll" />
          <AreaMeasure path="area-measure" />
          <LineItems path="line-items" type="MULTIFAMILY" />
          <Inflation path="inflation" />
        </Multifamily>
        <Folder path="folder">
          <FolderExplorer path="explorer" />
          <FolderSettings path="settings" />
          <FolderUW path="underwriting-workbook" />
          <PropertyList path="property-list" />
          <FolderReports path="reports" />
          <SnapshotsTable path="snapshots" type="folder"/>
          <FolderImportExport path="import-export" />
          <FolderAuditLog path="audit-log" />
        </Folder>
        <Property path="property">
          <AssetListDetail path="asset-info/:assetId" />
          <AreaMeasure path="area-measure" />
          <PropertyAssetAttributes path="asset-attributes" />
          <PropertySettings path="settings" />
          <ValuationSettings path="valuation-settings" />
          <Defaults path="defaults" />
          <SnapshotsTable path="snapshots" type="property"/>
          <PropertyImportExport path="import-export" />
          <PropertyAuditLog path="audit-log" />
        </Property>
        <RentRoll path="rent-roll">
          <RentRollTab path="home" />
          <MarketLease path="market-lease" />
          <RecoveryGroups path="recovery-groups" />
          <TenantGroups path="tenant-groups" />
          <NamedRecoveries path="named-recoveries" />
        </RentRoll>
        <MixedUse path="mixed-use">
          <MFRentRoll path="mf-rent-roll" />
          <LineItems path="line-items" type="MULTIFAMILY" />
          <PMInflation path="inflation" />
          <AreaMeasure path="area-measures" />
        </MixedUse>
        <LineItemsWrapper path="line-items">
          <LineItems path="all" type="COMMERCIAL" />
          <LineItems path="misc-income" litype="misc_income" type="COMMERCIAL" />
          <LineItems path="expense" litype="expense" type="COMMERCIAL" />
          <LineItems path="non-recoverable-expense" litype="expense_non_recov" type="COMMERCIAL" />
          <LineItems path="building-capital" litype="building_capital" type="COMMERCIAL" />
        </LineItemsWrapper>
        <PropertyMarket path="property-market">
          <PMInflation path="inflation" />
          <MarketLease path="market-lease" />
          <Downtime path="downtime" />
          <RenewalProbability path="renewal-probability" />
          <VacancyCreditLoss path="vacancy-credit-loss" />
        </PropertyMarket>
        <TenantMarket path="tenant-market">
          <TMRent path="rent" />
          <TMTI path="tenant-improvement" />
          <TMLC path="leasing-commissions" />
          <TMOC path="other-capital" />
          <TMFreeRent path="free-rent" />
          <TMIncrease path="increase" />
          <TMPayout path="payout" />
        </TenantMarket>
        <Recoveries path="recoveries">
          <AreaMeasure path="area-measure" />
          <NamedRecoveries path="named-recoveries" />
          <RecoveryPools path="recovery-pools" />
          <RecoveryPoolsDetail path="recovery-pools/:recoveryPoolId" />
          <RecoveryGroups path="recovery-groups" />
          <TenantContributions path="tenant-contributions" />
          <TenantGroups path="tenant-groups" />
          <ReportTags path="report-tags" />
        </Recoveries>
        <MFPropertyReports path="reports" />
        <UserAdmin path="admin">
          <Users path="users" />
          <UserGroups path="user-groups" />
          <OrgSettings path="organization-settings" />
          <SettingsAuditLog path="audit-log"/>
        </UserAdmin>
      </Wrapper>
    </Router>
  )
}

export default Routes